export const soundKitTypes = {
   soundKit: 'soundKit',
};

export const synthTypes = {
   sampler: 'sampler',
   multisampler: 'multisampler',
   subtractive: 'subtractive',
};

export const difficulties = {
   beginner: 1,
   easy: 2,
   medium: 3,
   hard: 4,
   expert: 5,
};

export const exerciseStages = {
   welcome: 'welcome',
   challenge: 'challenge',
   viewScore: 'viewScore',
   compareAnswer: 'compareAnswer',
   sessionOverview: 'sessionOverview',
   levelUp: 'levelUp',
   tutorial: 'tutorial',
   selectModules: 'selectModules',
   subscribePrompt: 'subscribePrompt',
   signUpPrompt: 'signUpPrompt',
   signUp: 'signUp',
};
